module.exports = __webpack_public_path__ + "static/p2-036642ffd5bcce34db2f6adec57c96a8.jpg";